// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingDetails-pageContent-Ldx_h {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.ListingDetails-titleText-yzoWV {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.ListingDetails-titleText-yzoWV:hover,
.ListingDetails-titleText-yzoWV:active,
.ListingDetails-titleText-yzoWV:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.ListingDetails-sectionTitleText-Z501R {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.ListingDetails-sectionTitleContent-cjc18 {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.ListingDetails-sectionCaptionLink-zfzki {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.ListingDetails-textMuted-Q8qlM,
.ListingDetails-textMuted-Q8qlM:hover,
.ListingDetails-textMuted-Q8qlM:focus,
.ListingDetails-textMuted-Q8qlM:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.ListingDetails-text-fgbNz {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.ListingDetails-textLine-Qw2zj {
	text-decoration: line-through;
}

.ListingDetails-textCenter-nrcZG {
	text-align: center;
}

.ListingDetails-textError-H8z7s {
	color: var(--alert-color);
}

.ListingDetails-horizontalLineThrough-lQKqj {
	position: relative;
	display: block;
}

.ListingDetails-pageContent-Ldx_h .ListingDetails-horizontalLineThrough-lQKqj:last-child {
	border-bottom: 0px;
}

.ListingDetails-space1-jYc8e {
	margin-bottom: 6px;
}

.ListingDetails-space2-wgSWL {
	margin-bottom: 12px;
}

.ListingDetails-space3-zutFZ {
	margin-bottom: 18px;
}

.ListingDetails-space4-MvACp {
	margin-bottom: 24px;
}

.ListingDetails-space5-BthBc {
	margin-bottom: 48px;
}

.ListingDetails-spaceTop1-vYxQo {
	margin-top: 6px;
}

.ListingDetails-spaceTop2-M77UR {
	margin-top: 12px;
}

.ListingDetails-spaceTop3-e1rsX {
	margin-top: 18px;
}

.ListingDetails-spaceTop4-C7Ew0 {
	margin-top: 24px;
}

.ListingDetails-spaceTop5-I73bP {
	margin-top: 48px;
}

.ListingDetails-padding1-nrVie {
	padding-bottom: 6px;
}

.ListingDetails-padding2-JtzIY {
	padding-bottom: 12px;
}

.ListingDetails-padding3-_70A0 {
	padding-bottom: 18px;
}

.ListingDetails-padding4-yjVhV {
	padding-bottom: 24px;
}

.ListingDetails-padding5-UwKS6 {
	padding-bottom: 48px;
}

.ListingDetails-paddingTop1-_TuY9 {
	padding-top: 6px;
}

.ListingDetails-paddingTop2-Lizoo {
	padding-top: 12px;
}

.ListingDetails-paddingTop3-aLGdg {
	padding-top: 18px;
}

.ListingDetails-paddingTop4-nwnQo {
	padding-top: 24px;
}

.ListingDetails-paddingTop5-axTj8 {
	padding-top: 48px;
}

.ListingDetails-noMargin-EcowP {
	margin: 0px;
}

.ListingDetails-noPadding-SJtjC {
	padding: 0px;
}

.ListingDetails-noBorder-MrE04 {
	border: 0px none !important;
}

.ListingDetails-btn-JlFdu {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: transparent;
	color: var(--primary-foreground);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.ListingDetails-btnBlock-lYbdN {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.ListingDetails-btn-JlFdu:hover,
.ListingDetails-btn-JlFdu:focus,
.ListingDetails-btn-JlFdu:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.ListingDetails-formControlSelect-G63ja {
	margin-bottom: 8px;
}

.ListingDetails-splitList-VFM7t {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.ListingDetails-displayTable-HZ7ut {
	display: table;
	width: 100%;
}

.ListingDetails-displayTableRow-luGht {
	display: table-row;
	width: 100%;
}

.ListingDetails-displayTableCell-fux8V {
	display: table-cell;
	width: 100%;
}

.ListingDetails-displayTableCellIcon-I4CXq {
	display: table-cell;
	vertical-align: top;
}

.ListingDetails-textMutedNew-CDYlj {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.ListingDetails-tableMarginTop-DHats {
	margin-top: 16px;
}

.ListingDetails-calendarTableCell-jNcOd {
	display: inline-block;
}

.ListingDetails-vrAlignTop-rjDfm {
	vertical-align: top;
}

.ListingDetails-currenyMarginR-Att8u {
	margin-right: 6px;
}

.ListingDetails-sectionLink-Np9Qj {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.ListingDetails-listingFontSize-NiU_0 {
	font-size: 16px !important;
}

.ListingDetails-vrAlignBottom-eNcZj {
	vertical-align: bottom;
}

.ListingDetails-introTextPadding-UqrXO {
	padding-left: 8px;
}

.ListingDetails-showHideBtn-ES44m {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.ListingDetails-showHideBtn-ES44m.ListingDetails-focus-G__Gu,
.ListingDetails-showHideBtn-ES44m:focus,
.ListingDetails-showHideBtn-ES44m:active,
.ListingDetails-showHideBtn-ES44m:active:focus,
.ListingDetails-showHideBtn-ES44m:focus,
.ListingDetails-showHideBtn-ES44m:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.ListingDetails-showHideMargin-ho52R {
	margin-bottom: 10px !important;
}

.ListingDetails-listingIntroWidth-LBMR5 {
	width: 65%;
}

.ListingDetails-showHidePadding-k9FQX {
	padding-bottom: 10px !important;
}

.ListingDetails-vtrTop-QTL8V {
	vertical-align: top;
}

.ListingDetails-listingLine-y7c0c {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ListingDetails-listingLineTwo-wRfxB {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.ListingDetails-titleText-yzoWV {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.ListingDetails-splitList-VFM7t {
		display: inline-block;
		width: 100% !important;
	}

	.ListingDetails-listingIntroWidth-LBMR5 {
		width: 100% !important;
	}

	.ListingDetails-responsiveListIngIntro-JAPYG {
		display: inline-block !important;
	}
}

.ListingDetails-sectionCaptionLink-zfzki {
	font-size: 16px;
	color: var(--primary-link-foreground);
	cursor: pointer;
	text-decoration: underline;
}

.ListingDetails-sectionCaptionLink-zfzki:hover,
.ListingDetails-sectionCaptionLink-zfzki:active,
.ListingDetails-sectionCaptionLink-zfzki:focus {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

.ListingDetails-imgSection-CzlSO {
	width: 100%;
	max-width: 28px;
	max-height: 28px;
	height: auto;
}

.ListingDetails-listIcon-WTr4V {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	width: 40px;
	height: 40px;
	vertical-align: top;
	margin-right: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	background: var(--secondary-gray-bg);
	border-radius: 50%;
}

.ListingDetails-listContent-eFMKN {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	display: inline-block;
	width: 85%;
	vertical-align: middle;
}

.ListingDetails-lineBreak-V8dFl {
	white-space: pre-line;
}

.ListingDetails-flex-x89up {
	font-size: 16px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	border: 1px solid var(--primary-border);
	min-width: 176px;
	max-width: 176px;
	padding: 20px;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
	margin-bottom: 20px;
	border-radius: 6px;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
}

.ListingDetails-grid-A1ZLI {
	display: grid;
	grid-template-columns: 24% 24% 24% 24%;
}

.ListingDetails-smallText-hEjjs {
	font-size: 14px;
	color: var(--secondary-foreground);
}

.ListingDetails-viewFlex-EF_rf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 4px;
	   -moz-column-gap: 4px;
	        column-gap: 4px;
}

.ListingDetails-viewFlex-EF_rf svg {
	width: 6px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.ListingDetails-rulesIconCss-uPQKg {
	margin-right: 8px;
}

.ListingDetails-collapseContainer-PDsEY {
	width: 100%;
}

@media screen and (max-width: 1200px) {
	.ListingDetails-grid-A1ZLI {
		grid-template-columns: 30.33% 30.33% 30.33%;
		grid-gap: 12px;
	}
}

@media screen and (max-width:1024px) {
	.ListingDetails-flex-x89up {
		width: 100%;
		min-width: 100%;
		max-width: 100%;
	}
}

@media screen and (min-width:768px) and (max-width:1024px) {
	.ListingDetails-flex-x89up {
		min-width: 95%;
		max-width: 95%;
	}
}

@media screen and (max-width: 767px) {
	.ListingDetails-grid-A1ZLI {
		grid-template-columns: 51% auto;
		;
	}
}

@media screen and (max-width: 480px) {
	.ListingDetails-grid-A1ZLI {
		grid-template-columns: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/ListingDetails/ListingDetails.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,uBAAuB;CACvB,gCAAgC;CAChC,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACjWA;CACC,eAAe;CACf,qCAAqC;CACrC,eAAe;CACf,0BAA0B;AAC3B;;AAEA;;;CAGC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uCAAuC;CACvC,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;CACb,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;CAC3B,mBAAmB;CACnB,kBAAkB;CAClB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,2CAA2C;EAC3C,cAAc;CACf;AACD;;AAEA;CACC;EACC,WAAW;EACX,eAAe;EACf,eAAe;CAChB;AACD;;AAEA;CACC;EACC,cAAc;EACd,cAAc;CACf;AACD;;AAEA;CACC;EACC,+BAA+B;;CAEhC;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}","@import '../common.css';\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n\n.sectionCaptionLink:hover,\n.sectionCaptionLink:active,\n.sectionCaptionLink:focus {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.imgSection {\n\twidth: 100%;\n\tmax-width: 28px;\n\tmax-height: 28px;\n\theight: auto;\n}\n\n.listIcon {\n\tdisplay: flex;\n\twidth: 40px;\n\theight: 40px;\n\tvertical-align: top;\n\tmargin-right: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: var(--secondary-gray-bg);\n\tborder-radius: 50%;\n}\n\n.listContent {\n\tflex: 1;\n\tdisplay: inline-block;\n\twidth: 85%;\n\tvertical-align: middle;\n}\n\n.lineBreak {\n\twhite-space: pre-line;\n}\n\n.flex {\n\tfont-size: 16px;\n\tdisplay: flex;\n\tborder: 1px solid var(--primary-border);\n\tmin-width: 176px;\n\tmax-width: 176px;\n\tpadding: 20px;\n\tjustify-content: flex-start;\n\tmargin-bottom: 20px;\n\tborder-radius: 6px;\n\tcolumn-gap: 10px;\n}\n\n.grid {\n\tdisplay: grid;\n\tgrid-template-columns: 24% 24% 24% 24%;\n}\n\n.smallText {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.viewFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 4px;\n}\n\n.viewFlex svg {\n\twidth: 6px;\n\tflex-shrink: 0;\n}\n\n.rulesIconCss {\n\tmargin-right: 8px;\n}\n\n.collapseContainer {\n\twidth: 100%;\n}\n\n@media screen and (max-width: 1200px) {\n\t.grid {\n\t\tgrid-template-columns: 30.33% 30.33% 30.33%;\n\t\tgrid-gap: 12px;\n\t}\n}\n\n@media screen and (max-width:1024px) {\n\t.flex {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t\tmax-width: 100%;\n\t}\n}\n\n@media screen and (min-width:768px) and (max-width:1024px) {\n\t.flex {\n\t\tmin-width: 95%;\n\t\tmax-width: 95%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.grid {\n\t\tgrid-template-columns: 51% auto;\n\t\t;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.grid {\n\t\tgrid-template-columns: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `ListingDetails-pageContent-Ldx_h`,
	"titleText": `ListingDetails-titleText-yzoWV`,
	"sectionTitleText": `ListingDetails-sectionTitleText-Z501R`,
	"sectionTitleContent": `ListingDetails-sectionTitleContent-cjc18`,
	"sectionCaptionLink": `ListingDetails-sectionCaptionLink-zfzki`,
	"textMuted": `ListingDetails-textMuted-Q8qlM`,
	"text": `ListingDetails-text-fgbNz`,
	"textLine": `ListingDetails-textLine-Qw2zj`,
	"textCenter": `ListingDetails-textCenter-nrcZG`,
	"textError": `ListingDetails-textError-H8z7s`,
	"horizontalLineThrough": `ListingDetails-horizontalLineThrough-lQKqj`,
	"space1": `ListingDetails-space1-jYc8e`,
	"space2": `ListingDetails-space2-wgSWL`,
	"space3": `ListingDetails-space3-zutFZ`,
	"space4": `ListingDetails-space4-MvACp`,
	"space5": `ListingDetails-space5-BthBc`,
	"spaceTop1": `ListingDetails-spaceTop1-vYxQo`,
	"spaceTop2": `ListingDetails-spaceTop2-M77UR`,
	"spaceTop3": `ListingDetails-spaceTop3-e1rsX`,
	"spaceTop4": `ListingDetails-spaceTop4-C7Ew0`,
	"spaceTop5": `ListingDetails-spaceTop5-I73bP`,
	"padding1": `ListingDetails-padding1-nrVie`,
	"padding2": `ListingDetails-padding2-JtzIY`,
	"padding3": `ListingDetails-padding3-_70A0`,
	"padding4": `ListingDetails-padding4-yjVhV`,
	"padding5": `ListingDetails-padding5-UwKS6`,
	"paddingTop1": `ListingDetails-paddingTop1-_TuY9`,
	"paddingTop2": `ListingDetails-paddingTop2-Lizoo`,
	"paddingTop3": `ListingDetails-paddingTop3-aLGdg`,
	"paddingTop4": `ListingDetails-paddingTop4-nwnQo`,
	"paddingTop5": `ListingDetails-paddingTop5-axTj8`,
	"noMargin": `ListingDetails-noMargin-EcowP`,
	"noPadding": `ListingDetails-noPadding-SJtjC`,
	"noBorder": `ListingDetails-noBorder-MrE04`,
	"btn": `ListingDetails-btn-JlFdu`,
	"btnBlock": `ListingDetails-btnBlock-lYbdN`,
	"formControlSelect": `ListingDetails-formControlSelect-G63ja`,
	"splitList": `ListingDetails-splitList-VFM7t`,
	"displayTable": `ListingDetails-displayTable-HZ7ut`,
	"displayTableRow": `ListingDetails-displayTableRow-luGht`,
	"displayTableCell": `ListingDetails-displayTableCell-fux8V`,
	"displayTableCellIcon": `ListingDetails-displayTableCellIcon-I4CXq`,
	"textMutedNew": `ListingDetails-textMutedNew-CDYlj`,
	"tableMarginTop": `ListingDetails-tableMarginTop-DHats`,
	"calendarTableCell": `ListingDetails-calendarTableCell-jNcOd`,
	"vrAlignTop": `ListingDetails-vrAlignTop-rjDfm`,
	"currenyMarginR": `ListingDetails-currenyMarginR-Att8u`,
	"sectionLink": `ListingDetails-sectionLink-Np9Qj`,
	"listingFontSize": `ListingDetails-listingFontSize-NiU_0`,
	"vrAlignBottom": `ListingDetails-vrAlignBottom-eNcZj`,
	"introTextPadding": `ListingDetails-introTextPadding-UqrXO`,
	"showHideBtn": `ListingDetails-showHideBtn-ES44m`,
	"focus": `ListingDetails-focus-G__Gu`,
	"showHideMargin": `ListingDetails-showHideMargin-ho52R`,
	"listingIntroWidth": `ListingDetails-listingIntroWidth-LBMR5`,
	"showHidePadding": `ListingDetails-showHidePadding-k9FQX`,
	"vtrTop": `ListingDetails-vtrTop-QTL8V`,
	"listingLine": `ListingDetails-listingLine-y7c0c`,
	"listingLineTwo": `ListingDetails-listingLineTwo-wRfxB`,
	"responsiveListIngIntro": `ListingDetails-responsiveListIngIntro-JAPYG`,
	"imgSection": `ListingDetails-imgSection-CzlSO`,
	"listIcon": `ListingDetails-listIcon-WTr4V`,
	"listContent": `ListingDetails-listContent-eFMKN`,
	"lineBreak": `ListingDetails-lineBreak-V8dFl`,
	"flex": `ListingDetails-flex-x89up`,
	"grid": `ListingDetails-grid-A1ZLI`,
	"smallText": `ListingDetails-smallText-hEjjs`,
	"viewFlex": `ListingDetails-viewFlex-EF_rf`,
	"rulesIconCss": `ListingDetails-rulesIconCss-uPQKg`,
	"collapseContainer": `ListingDetails-collapseContainer-PDsEY`
};
module.exports = ___CSS_LOADER_EXPORT___;
